module.exports = {
      id: "personas:four-usage",
      viewBox: "0 0 40 42",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#personas:four-usage",
      toString: function () {
        return this.url;
      }
    }